import Swal from "sweetalert2";
import { ensureMixedWordExportStyles, mixedWordExportDialogHtml } from "./mixedWordExportDialog";

export async function chooseMixedWordExport(signal) {
  if (signal?.aborted) return null;
  ensureMixedWordExportStyles();
  const abort = () => Swal.close?.();
  signal?.addEventListener("abort", abort, { once: true });
  try {
    const result = await Swal.fire({
      html: mixedWordExportDialogHtml(),
      customClass: { popup: "mixed-word-export-dialog" },
      width: "min(580px, calc(100vw - 32px))", padding: "28px",
      showConfirmButton: false, showCancelButton: false, showCloseButton: false,
      allowEnterKey: false,
      didOpen: (popup) => {
        const container = Swal.getContainer?.(); if (container) container.style.zIndex = "4000";
        if (document.querySelector('[data-auth-theme="night"]')) popup.dataset.theme = "dark";
        popup.setAttribute("aria-labelledby", "mixed-export-dialog-title");
        popup.querySelectorAll("[data-mixed-version]").forEach((button) => button.addEventListener("click", () => Swal.close({ isConfirmed: true, value: button.dataset.mixedVersion })));
        popup.querySelector("[data-mixed-close]").addEventListener("click", () => Swal.close());
        popup.querySelector("[data-mixed-version]").focus();
      },
    });
    if (signal?.aborted) return null;
    if (["teacher", "student", "both"].includes(result?.value)) return result.value;
    // Retain compatibility with existing confirm/deny integrations.
    if (result?.isConfirmed) return "teacher";
    if (result?.isDenied) return "student";
    return result?.dismiss === "cancel" ? "both" : null;
  } finally {
    signal?.removeEventListener("abort", abort);
  }
}
